import React from "react";
import "../styles/bookingOverlay.css";

const BookingOverlay = ({
  isOpen,
  onClose,
  loading,
  contactDetails,
  handleChange,
  handleSubmit,
  requestSuccess,
}) => {
  if (!isOpen) return null;

  return (
    <div className="booking-overlay">
      <div className="overlay-content">
        {requestSuccess ? (
          <div className="success-message">
            <h2>Your booking has been received!</h2>
            <p>Kindly wait for our team to reach out to you as soon as possible.</p>
           
           <div className="success-btns">
           <button onClick={onClose}>
              Back 
            </button>
           <button>
              <a href="/">Go to Homepage</a>
            </button>
           </div>

          </div>
        ) : (
          <>
            <h2>Enter Contact Details</h2>
            <form onSubmit={handleSubmit}>
              <label>
                Name:
                <input
                  type="text"
                  name="name"
                  value={contactDetails.name}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                Email:
                <input
                  type="email"
                  name="email"
                  value={contactDetails.email}
                  onChange={handleChange}
                  required
                />
              </label>

              <label>
                Phone:
                <input
                  type="tel"
                  name="phone"
                  value={contactDetails.phone}
                  onChange={handleChange}
                  required
                />
              </label>

              <label className="mt-3">
                Preferred Contact Method:
                <div className="contact-method">
                  <label>
                    <input
                      type="radio"
                      name="contactMethod"
                      value="Email"
                      checked={contactDetails.contactMethod === "Email"}
                      onChange={handleChange}
                    />
                    Email
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="contactMethod"
                      value="WhatsApp"
                      checked={contactDetails.contactMethod === "WhatsApp"}
                      onChange={handleChange}
                    />
                    WhatsApp
                  </label>
                </div>
              </label>

              <div className="form-actions">
                <button type="submit" className="submit-btn">
                {loading ? "Processing..." : "Submit"}
                </button>
                <button type="button" className="cancel-btn" onClick={onClose}>
                  Cancel
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default BookingOverlay;
